import { Component, Inject } from '@angular/core';
import { BehaviorSubject, combineLatest, Observable, switchMap } from 'rxjs';
import { DocumentType, SearchIndexDocument } from '@jessie/commons';
import { DocumentService, mapToSearchIndexDocuments } from '../../../services/document.service';
import { map, tap } from 'rxjs/operators';
import { NgIconWrapperComponent } from '../../../components/icons/ng-icon-wrapper/ng-icon-wrapper.component';
import { DocumentCardComponent } from './document-card/document-card.component';
import { AsyncPipe } from '@angular/common';
import { Dialog } from '@angular/cdk/dialog';
import { DocumentSlideOverComponent } from '../document-slide-over/document-slide-over.component';

@Component({
    selector: 'app-inbox',
    templateUrl: './inbox.component.html',
    imports: [DocumentCardComponent, NgIconWrapperComponent, AsyncPipe]
})
export class InboxComponent {
  documents$: Observable<SearchIndexDocument[]>;

  searchValue = new BehaviorSubject<string | null>(null);
  limitRows = new BehaviorSubject<boolean>(true);
  typeFilter = new BehaviorSubject<DocumentType[]>(['revenue', 'expense', 'other']);

  constructor(
    private documentService: DocumentService,
    @Inject(Dialog) private dialog: Dialog
  ) {
    this.documents$ = combineLatest([
      combineLatest([this.limitRows, this.typeFilter]).pipe(
        switchMap(([limitRows, typeFilter]) =>
          this.documentService.getDocumentsInArchive(null, false, typeFilter, limitRows ? 10 : 0)
        )
      ),
      this.searchValue.pipe(
        tap((x) => {
          if (x) {
            this.limitRows.next(false);
          }
        })
      ),
    ]).pipe(
      map(([documents, searchValue]) => {
        return searchValue
          ? documents.filter((document) => {
              return (
                document.data.name.toLowerCase().indexOf(searchValue.toLowerCase()) >= 0 ||
                (document.data.documentText
                  ? document.data.documentText.toLowerCase().indexOf(searchValue.toLowerCase()) >= 0
                  : false)
              );
            })
          : documents;
      }),
      map(mapToSearchIndexDocuments)
    );
  }

  editDocument(documents: SearchIndexDocument[]) {
    this.dialog.open(DocumentSlideOverComponent, { data: { documents: documents } });
  }

  async deleteDocument(documents: SearchIndexDocument[]) {
    await Promise.all(
      documents.map((document) => this.documentService.deleteDocumentByPath(document.path))
    );
  }
}
